import React, { useState } from "react";

const InputDropdown = ({
  label,
  value,
  options,
  placeholder = "Select or enter",
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const getLabel = (option) =>
    typeof option === "string" ? option : option.label;

  const getValue = (option) =>
    typeof option === "string" ? option : option.value;

  const displayValue =
    options.find(
      (option) =>
        typeof option === "object" && option.value === value
    )?.label || value;

  const filteredOptions = options.filter((option) =>
    getLabel(option)
      .toLowerCase()
      .includes((displayValue || "").toLowerCase())
  );

  return (
    <div className="position-relative">
      {label && <label>{label}</label>}

      <input
        type="text"
        className="form-control"
        value={displayValue}
        placeholder={placeholder}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setTimeout(() => setIsOpen(false), 200)}
        onChange={(e) => {
          onChange(e.target.value);
          setIsOpen(true);
        }}
      />

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #ced4da",
            borderRadius: "0.375rem",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            maxHeight: "200px",
            overflowY: "auto",
            marginTop: "2px",
          }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={getValue(option)}
                onMouseDown={() => {
                  onChange(getValue(option));
                  setIsOpen(false);
                }}
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  borderBottom: "1px solid #f1f1f1",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f8f9fa")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fff")
                }
              >
                {getLabel(option)}
              </div>
            ))
          ) : (
            <div
              style={{
                padding: "8px 12px",
                color: "#6c757d",
              }}
            >
              Custom value
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InputDropdown;